import { EditPencile } from "../reusableComponents/svgIcons";
import {
  formatDateLL,
  formatDatelll,
  ScrollToTop,
} from "./../../algorithms/index";
import { useEffect } from "react";
const UserInfo = ({ details }) => {
  useEffect(() => {
    ScrollToTop();
  }, []);
  return (
    <div
      className="d-flex flex-column container col-10 mt-4 py-3 mb-5"
      style={{
        height: "fit-content",
        border: "1px solid rgb(199, 199, 201)",
        borderRadius: 10,
      }}
    >
      <div className="d-flex col-12 pb-2">
        <div className="col-11">
          <p className="mb-0" style={{ color: "#1a73e8" }}>
            المعلومات الشخصية
          </p>
        </div>
        <div className="col-1 d-flex align-items-center justify-content-end">
          {EditPencile(20, 20, "#1a73e8", () => {})}
        </div>
      </div>

      <hr className="m-0" />

      <div className="d-flex  flex-md-row flex-wrap col-12 pt-3">
        <div className="col-md-3 col-6 d-flex justify-content-center">
          <div className="col-11">
            {details?.birthDate ? (
              <div className="d-flex flex-column col-12 mb-4">
                <p className="m-0 col-12 text-muted" style={{ fontSize: 14 }}>
                  تاريخ الميلاد
                </p>
                <p className="m-0 col-12 text-dark" style={{ fontSize: 16 }}>
                  {formatDateLL(details?.birthDate) ?? null}
                </p>
              </div>
            ) : null}

            {details?.phoneNumber ? (
              <div className="d-flex flex-column col-12 mb-4">
                <p className="m-0 col-12 text-muted" style={{ fontSize: 14 }}>
                  رقم الهاتف
                </p>
                <p className="m-0 col-12 text-dark" style={{ fontSize: 16 }}>
                  {details?.phoneNumber ?? null}
                </p>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-md-3 col-6 d-flex justify-content-center">
          <div className="col-11">
            {details?.nationalityName ? (
              <div className="d-flex flex-column col-12 mb-4">
                <p className="m-0 col-12 text-muted" style={{ fontSize: 14 }}>
                  الجنسية
                </p>
                <p className="m-0 col-12 text-dark" style={{ fontSize: 16 }}>
                  {details?.nationalityName ?? null}
                </p>
              </div>
            ) : null}

            {details?.mobileNumber ? (
              <div className="d-flex flex-column col-12 mb-4">
                <p className="m-0 col-12 text-muted" style={{ fontSize: 14 }}>
                  رقم الهاتف
                </p>
                <p className="m-0 col-12 text-dark" style={{ fontSize: 16 }}>
                  {details?.mobileNumber ?? null}
                </p>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-md-3 col-6 d-flex justify-content-center">
          <div className="col-11">
            {details?.address ? (
              <div className="d-flex flex-column col-12 mb-4">
                <p className="m-0 col-12 text-muted" style={{ fontSize: 14 }}>
                  محل الإقامة
                </p>
                <p className="m-0 col-12 text-dark" style={{ fontSize: 16 }}>
                  {details?.address ?? null}
                </p>
              </div>
            ) : null}

            {details?.email ? (
              <div className="d-flex flex-column col-12 mb-4">
                <p className="m-0 col-12 text-muted" style={{ fontSize: 14 }}>
                  البريد الإلكتروني
                </p>
                <p className="m-0 col-12 text-dark" style={{ fontSize: 16 }}>
                  {details?.email ?? null}
                </p>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-md-3 col-6 d-flex justify-content-center">
          <div className="col-11">
            {details?.titleName ? (
              <div className="d-flex flex-column col-12 mb-4">
                <p className="m-0 col-12 text-muted" style={{ fontSize: 14 }}>
                  اللقب
                </p>
                <p className="m-0 col-12 text-dark" style={{ fontSize: 16 }}>
                  {details?.titleName ?? null}
                </p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
